import { render, staticRenderFns } from "./RegisterCandidate.vue?vue&type=template&id=017f39fc&scoped=true"
import script from "./RegisterCandidate.vue?vue&type=script&lang=js"
export * from "./RegisterCandidate.vue?vue&type=script&lang=js"
import style0 from "./RegisterCandidate.vue?vue&type=style&index=0&id=017f39fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017f39fc",
  null
  
)

export default component.exports